import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { Loader2 } from "lucide-react";

export default function AdminSplitTest() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ["/api/admin/split-test/stats"],
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gothic-black">
        <Loader2 className="w-8 h-8 animate-spin text-blood-red" />
      </div>
    );
  }

  const chartData = [
    {
      name: "Group A (Timed)",
      views: stats?.A?.views || 0,
      conversions: stats?.A?.conversions || 0,
      rate: stats?.A?.views ? ((stats.A.conversions / stats.A.views) * 100).toFixed(1) : 0,
    },
    {
      name: "Group B (Exit)",
      views: stats?.B?.views || 0,
      conversions: stats?.B?.conversions || 0,
      rate: stats?.B?.views ? ((stats.B.conversions / stats.B.views) * 100).toFixed(1) : 0,
    },
    {
      name: "Group C (Manual Click)",
      views: stats?.C?.views || 0,
      conversions: stats?.C?.conversions || 0,
      rate: stats?.C?.views ? ((stats.C.conversions / stats.C.views) * 100).toFixed(1) : 0,
    },
  ];

  return (
    <div className="p-8 pt-24 bg-gothic-black min-h-screen text-gothic-white">
      <h1 className="text-4xl font-playfair font-bold text-blood-red mb-8">Split Test Dashboard</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
        {chartData.map((group) => (
          <Card key={group.name} className="bg-gothic-charcoal border-gothic-gray">
            <CardHeader>
              <CardTitle className="text-blood-red">{group.name}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <p className="text-sm text-gray-400">Views</p>
                  <p className="text-2xl font-bold">{group.views}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-400">Conversions</p>
                  <p className="text-2xl font-bold">{group.conversions}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-400">Conv. Rate</p>
                  <p className="text-2xl font-bold text-blood-red">{group.rate}%</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="bg-gothic-charcoal border-gothic-gray p-6">
        <CardHeader>
          <CardTitle className="text-gothic-white mb-4">Visual Comparison</CardTitle>
        </CardHeader>
        <div className="h-[400px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
              <XAxis dataKey="name" stroke="#9ca3af" />
              <YAxis stroke="#9ca3af" />
              <Tooltip 
                contentStyle={{ backgroundColor: "#1a1a1a", border: "1px solid #4b5563" }}
                itemStyle={{ color: "#f3f4f6" }}
              />
              <Legend />
              <Bar dataKey="views" fill="#4b5563" name="Views" />
              <Bar dataKey="conversions" fill="#880808" name="Conversions" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
}
